export default {
  translation: {
    common: {
      emailOrUsername: 'البريد الإلكتروني أو اسم المستخدم',
      invalidEmailOrUsername: 'البريد الإلكتروني أو اسم المستخدم غير صالح',
      invalidCredentials: 'بيانات الاعتماد غير صالحة',
      invalidPassword: 'كلمة المرور غير صالحة',
      noInternetConnection: 'لا يوجد اتصال بالإنترنت',
      pageNotFound_title: 'الصفحة غير موجودة',
      password: 'كلمة المرور',
      projectManagement: 'إدارة المشروع',
      serverConnectionFailed: 'فشل الاتصال بالخادم',
      unknownError: 'خطأ غير معروف، يرجى المحاولة لاحقاً',
      useSingleSignOn: 'استخدم تسجيل الدخول الموحد',
    },

    action: {
      logIn: 'تسجيل الدخول',
      logInWithSSO: 'تسجيل الدخول باستخدام SSO',
    },
  },
};
